import { Fragment } from 'react';
import { formatSlots } from '~/components/calendar-with-filters';

const { formatTimeToPeriod } = formatSlots;

export const config = {
  AboutIntro: {
    title: 'About you',
  },
  AboutYouForm: {
    sectionDataTest: 'YourAppointmentHomeDesignAtHome',
    formatTimeSlot: startTime => (
      <Fragment>
        ,&nbsp;
        <span>
          {formatTimeToPeriod(startTime)}
        </span>
      </Fragment>
    ),
  },
};
